import { apiRequest } from './axiosConfig';

export interface Tag {
  id: number;
  name: string;
  slug: string;
  created_at?: string;
  updated_at?: string;
}

export interface TagsResponse {
  data: Tag[];
}

class TagService {
  /**
   * Get all tags
   * @returns List of all tags
   */
  async getAll(): Promise<TagsResponse> {
    try {
      console.log('Tag一覧取得を開始します...');

      const config = { timeout: 30000 };
      const response = await apiRequest.get<TagsResponse>('tags', config);

      console.log(`Tag一覧取得が完了しました (${response.data?.length || 0}件)`);
      return response;
    } catch (error: any) {
      console.error('Tag一覧取得に失敗しました:', error?.message || 'エラー詳細不明');
      throw error;
    }
  }

  /**
   * Get tag by ID
   * @param tagId Tag ID
   * @returns Tag details
   */
  async getById(tagId: number): Promise<{ data: Tag }> {
    try {
      console.log(`Tag(ID: ${tagId})取得を開始します...`);

      const config = { timeout: 30000 };
      const response = await apiRequest.get<{ data: Tag }>(`tags/${tagId}`, config);

      console.log('Tag取得が完了しました');
      return response;
    } catch (error: any) {
      console.error(`Tag(ID: ${tagId})の取得に失敗しました:`, error?.message || 'エラー詳細不明');
      throw error;
    }
  }

  /**
   * Create new tag
   * @param data Tag creation data
   * @returns Created tag
   */
  async create(data: { name: string; slug?: string }): Promise<{ data: Tag }> {
    try {
      console.log('Tag作成を開始します...', data.name);

      const config = { timeout: 30000 };
      const response = await apiRequest.post<{ data: Tag }>('tags', data, config);

      console.log('Tag作成が完了しました');
      return response;
    } catch (error: any) {
      console.error('Tag作成に失敗しました:', error?.message || 'エラー詳細不明');
      throw error;
    }
  }

  /**
   * Update tag
   * @param tagId Tag ID
   * @param data Tag update data
   * @returns Updated tag
   */
  async update(tagId: number, data: { name?: string; slug?: string }): Promise<{ data: Tag }> {
    try {
      console.log(`Tag(ID: ${tagId})更新を開始します...`);

      const config = { timeout: 30000 };
      const response = await apiRequest.put<{ data: Tag }>(`tags/${tagId}`, data, config);

      console.log('Tag更新が完了しました');
      return response;
    } catch (error: any) {
      console.error(`Tag(ID: ${tagId})の更新に失敗しました:`, error?.message || 'エラー詳細不明');
      throw error;
    }
  }

  /**
   * Delete tag
   * @param tagId Tag ID
   * @returns Success message
   */
  async delete(tagId: number): Promise<{ message: string }> {
    try {
      console.log(`Tag(ID: ${tagId})削除を開始します...`);

      const config = { timeout: 30000 };
      const response = await apiRequest.delete<{ message: string }>(`tags/${tagId}`, config);

      console.log('Tag削除が完了しました');
      return response;
    } catch (error: any) {
      console.error(`Tag(ID: ${tagId})の削除に失敗しました:`, error?.message || 'エラー詳細不明');
      throw error;
    }
  }
}

export default new TagService();
